import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Server-driven pagination, reused across Scope B admin list pages (M2+).
 * Parent owns page + pageSize state; this component is purely presentational.
 */
export default function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50, 100],
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div
      data-testid="pagination"
      className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mt-6 text-sm text-brand-muted"
    >
      <div data-testid="pagination-summary">
        {total === 0
          ? "No entries"
          : `Showing ${start}–${end} of ${total}`}
      </div>
      <div className="flex items-center gap-3">
        <label className="flex items-center gap-2">
          <span className="hidden sm:inline">Per page</span>
          <select
            data-testid="pagination-size"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="border border-brand-linen bg-white px-2 py-1"
          >
            {pageSizeOptions.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </label>
        <div className="flex items-center gap-1">
          <button
            data-testid="pagination-prev"
            onClick={() => canPrev && onPageChange(page - 1)}
            disabled={!canPrev}
            className="px-2 py-1 border border-brand-linen bg-white disabled:opacity-40"
            aria-label="Previous page"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
          <span data-testid="pagination-current" className="px-3 font-serif text-brand-ink">
            {page} / {totalPages}
          </span>
          <button
            data-testid="pagination-next"
            onClick={() => canNext && onPageChange(page + 1)}
            disabled={!canNext}
            className="px-2 py-1 border border-brand-linen bg-white disabled:opacity-40"
            aria-label="Next page"
          >
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
